import React from 'react';
import { useIntl } from 'react-intl';

import { LoadingWizardScreen } from '@futrli/ui-components/components/sidebar/wizard/screens/loading-wizard-screen/loading-wizard-screen';

export const UserUpdatingWizardScreen = () => {
  const intl = useIntl();

  return (
    <LoadingWizardScreen
      text={intl.formatMessage({
        id: 'predict.workspaces.users.modify.saving',
        defaultMessage: 'Saving changes...'
      })}
    />
  );
};
